<template>
  <!-- :placeholder="item.full_name"  -->
  <VInput
    v-if="item.type === 1"
    v-model="item.options[0].name"
    :name="item.group_name"
    type="number"
    :class="classItem"
    :disabled="isDisabled" />

  <VSelect
    v-else
    v-model="item.is_selected"
    :class="classItem"
    :name="item.group_name"
    :options="item.options"
    :disabled="isDisabled" />
</template>

<script setup>
import VInput from '@/components/ui/form/VInput'
import VSelect from '@/components/ui/form/VSelect'
import { defineProps } from 'vue'

defineProps({
  item: {
    type: Object,
    required: true,
  },
  classItem: {
    type: String,
    required: false,
  },
  isDisabled: {
    type: Boolean,
    required: false,
  },
})
</script>
